module.exports = __webpack_public_path__ + "img/meeple.72fdb11c.svg";